export interface IGetAssetCategoryImportedDto {
    name: string
    description: string
    division: string
}

export class AssetCategoryImported {
    name: string
    description: string
    division: string

    constructor(dto: IGetAssetCategoryImportedDto) {
        this.name = dto.name
        this.description = dto.description
        this.division = dto.division
    }
}
